
import { useTranslation } from "react-i18next";
import Hero from "../../components/hero/Hero";
import { ICallToAction } from "../../components/hero/IHeroProps";
import SEO from "../../app/SEO";
import { makeStyles } from "@fluentui/react-components";
import { useHeroMainSnap } from "../../hooks/useHeroMainSnap";
import Tagline from "./Tagline";
import KeyServices from "./KeyServices";
import PromotedImage from "./PromotedImage";
import Platforms from "./Platforms";
import Blog from "../../pages/home/Blog";

const useStyles = makeStyles({
    root: {
        width: "100%",
        height: "100%"
    },
    heroWrapper: {
        width: "100%",
        height: "auto"
    },
    mainWrapper: {
        position: "relative",
        width: "100%"
    }
});

const clientLogos = [
    { src: "img/home/client-logos/woody-white.png", alt: "Woodmansterne Ltd" },
    { src: "img/home/client-logos/true-white.png", alt: "True" },
    { src: "img/home/client-logos/dctr-white.png", alt: "DCTR" },
    { src: "img/home/client-logos/macro-offwhite.svg", alt: "Macro Group Ltd" },
    { src: "img/home/client-logos/maxbarney-white.png", alt: "Max Barney Ltd" }
];

const SupportSite = () => {
    const { t } = useTranslation("helpdesk");
    const styles = useStyles();

    const cta: ICallToAction = {
        text: t("hero.callToAction"),
        url: "/contact"
    };

    useHeroMainSnap("home-hero", "home-main", {
        duration: 900,
        easing: "quart",
        heroCapturePx: 80,
        upCapturePx: 300,
        headerOffset: 0
    });

    return (
        <div className={styles.root}>
            <SEO />

            <div id="home-hero" className={styles.heroWrapper}>
                <Hero
                    title={t("hero.title")}
                    subtitle={t("hero.description")}
                    cta={cta}
                    videoUri="/video/top-banner-video-h264.mp4"
                    videoPreviewUri="/video/top-banner-video-preview.webp"
                    clientLogos={clientLogos}
                    showScrollHint={false}
                    scrollTargetId="home-main"
                />
            </div>

            <div id="home-main" className={styles.mainWrapper}>
                <Tagline />
                <KeyServices />
                <Platforms />
                <PromotedImage />
                <Blog />
            </div>
        </div>
    );
};

export default SupportSite;
